import { OnboardingDataStatus } from 'api/types/data';
import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';

import { Section } from '../../../Section/Section';

import { StatusFields } from './components';

export interface FormContentProps {
  statuses?: OnboardingDataStatus[];
}

export const FormContent = ({ statuses }: FormContentProps) => {
  const { t } = useTranslation();

  return (
    <Stack spacing={24}>
      {statuses?.map(({ value, createdBy, createdAt, result }) => (
        <Section
          key={value}
          title={t(
            `client.client.resultCheckSection.statuses.${value}.subtitle`
          )}
        >
          <StatusFields
            createdAt={createdAt}
            createdBy={createdBy}
            result={result}
          />
        </Section>
      ))}
    </Stack>
  );
};
